import { render, staticRenderFns } from "./FaturamentoTabList.vue?vue&type=template&id=648b17e0&scoped=true"
import script from "./FaturamentoTabList.vue?vue&type=script&lang=js"
export * from "./FaturamentoTabList.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoTabList.vue?vue&type=style&index=0&id=648b17e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b17e0",
  null
  
)

export default component.exports